import React, {Component, useState} from "react";
import { MdOutlineArrowBackIos} from "react-icons/md";

import WithUserData from "../../WithUserData";
import UpdateEmailModal from "./update-email-modal";
import UpdatePhoneModal from "./update-phone-modal";
import UpdateFieldModal from "./update-field-modal";
import {IoIosArrowForward} from "react-icons/io";
import ReCAPTCHA from "react-google-recaptcha";
import {Link} from "react-router-dom";

export default class ContactInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formResetKey: 0
        };
    }

    render() {
        return (
            <WithUserData>
                {({ user }) => {
                    return (
                        <div className='w-full h-full flex flex-col justify-between px-2'>
                            <div className="w-full h-16 flex justify-between items-center mt-6">
                                <Link
                                    to="/account/edit-profile"
                                    className="ml-0 cursor-pointer w-24 py-2 border border-black text-gray-900 rounded-lg flex items-center mx-auto hover:bg-gray-200"
                                >
                                    <div className="w-10 flex items-center justify-center">
                                        <MdOutlineArrowBackIos size={18}/>
                                    </div>
                                    <span>Back</span>
                                </Link>
                                <div className="text-black text-2xl font-bold mr-10">Contact Info</div>
                            </div>
                            <ContactInfoForm
                                key={this.state.formResetKey}
                                defaultValues={user}
                                onSuccess={() => this.setState({ formResetKey: this.state.formResetKey + 1 })}
                            />
                        </div>
                    )
                }}
            </WithUserData>
        );
    }
}

const ContactInfoForm = ({ defaultValues, onSuccess }) => {

    const recaptchaRef = React.useRef(null);
    const [fieldToUpdate, setFieldToUpdate] = useState({})
    const [showEmailModal, setShowEmailModal] = useState(false)
    const [showPhoneNumberModal, setShowPhoneNumberModal] = useState(false)

    const isAppReviewerEmail = defaultValues.email === process.env.REACT_APP_APP_REVIEWER_EMAIL;

    return (
        <>
            <div className=" space-y-4 max-w-md z-1 pb-20 mt-6">
                <div>
                    <label className="block mb-1 text-black">Email address:</label>
                    <div className={`p-1 flex w-full items-center justify-between rounded text-black ${isAppReviewerEmail ? "bg-gray-200" : "cursor-pointer bg-white hover:bg-gray-200"}`}
                         onClick={() => {
                             if (!isAppReviewerEmail) setShowEmailModal(true)
                         }}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.email}
                        </div>
                        {!isAppReviewerEmail && <IoIosArrowForward/>}
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">First name:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                         onClick={() => setFieldToUpdate({
                             label: "First Name",
                             key: "firstName",
                             options: {required: "First name is required"}
                         })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.firstName}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">Last name:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                         onClick={() => setFieldToUpdate({
                             label: "Last Name",
                             key: "lastName",
                             options: {required: "Last name is required"}
                         })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.lastName}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>

                <div>
                    <label className="block mb-1 text-black">Phone number:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                         onClick={() => setShowPhoneNumberModal(true)}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {`${defaultValues.phoneNumber}`}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">Address:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                        // onClick={() => setFieldToUpdate({
                        //     label: "Address",
                        //     key: "address",
                        //     options: {}
                        // })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.address}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">City:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                        // onClick={() => setFieldToUpdate({
                        //     label: "City",
                        //     key: "city",
                        //     options: {}
                        // })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.city}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">Postcode:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                        // onClick={() => setFieldToUpdate({
                        //     label: "Postcode",
                        //     key: "postcode",
                        //     options: {}
                        // })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.postcode}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">Country:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                        // onClick={() => setFieldToUpdate({
                        //     label: "Country",
                        //     key: "country",
                        //     options: {}
                        // })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.country}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>

                <div>
                    <label className="block mb-1 text-black">Home base city:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                         onClick={() => setFieldToUpdate({
                             label: "Home base city:",
                             key: "homeCity",
                             options: {required: "Home city is required"}
                         })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.homeCity.name}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">Tiktok:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                         // onClick={() => setFieldToUpdate({
                         //     label: "Tiktok",
                         //     key: "tiktok",
                         //     options: {}
                         // })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.tiktok}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
                <div>
                    <label className="block mb-1 text-black">Website:</label>
                    <div className="p-1 flex w-full items-center justify-between rounded text-black cursor-pointer bg-white hover:bg-gray-200"
                         // onClick={() => setFieldToUpdate({
                         //     label: "Website",
                         //     key: "website",
                         //     options: {}
                         // })}
                         style={{
                             border: "1px solid",
                             borderColor: "#404040"
                         }}>
                        <div className="p-2 h-10">
                            {defaultValues.website}
                        </div>
                        <IoIosArrowForward />
                    </div>
                </div>
            </div>
            {fieldToUpdate?.key && <UpdateFieldModal fieldToUpdate={fieldToUpdate} setFieldToUpdate={setFieldToUpdate}
                               defaultValues={defaultValues} onSuccess={onSuccess}/>}
            <UpdateEmailModal showEmailModal={showEmailModal} setShowEmailModal={setShowEmailModal} oldEmail={defaultValues.email} onSuccess={onSuccess} recaptchaRef={recaptchaRef} />
            <UpdatePhoneModal showPhoneNumberModal={showPhoneNumberModal} setShowPhoneNumberModal={setShowPhoneNumberModal} oldPhoneNumber={defaultValues.phoneNumber} onSuccess={onSuccess} recaptchaRef={recaptchaRef} />
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            />
        </>
    )
}
